<template>
    <ToolbarButton
        :icon="downloadIcon"
        label="Download CSV"
        @click.native="exportCsv()" />
</template>

<script>
import DownloadIcon from 'voluum-frontend-icons/download.svg';

import Icon from './Icon';
import ToolbarButton from './ToolbarButton';

export default {
    name: 'CsvButton',

    components: {
        Icon,
        ToolbarButton
    },

    data: function () {
        return {
            downloadIcon: DownloadIcon
        };
    },

    methods: {
        exportCsv: function () {
            this.$store.dispatch('downloadCSVReport');
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/CsvButton.vue